"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _apis = require("../../common/apis");
var _nicheUserFeService = require("niche-user-fe-service");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
const NicheGoogleAuthRedirect = props => {
  const location = (0, _reactRouterDom.useLocation)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  const queryString = location.search;
  const getGoogleAuthToken = (0, _react.useCallback)(async () => {
    await (0, _nicheUserFeService.googleLogin)(_apis.googleAuthRedirectUrl, queryString).then(res => {
      if (res?.data?.authToken) {
        localStorage.setItem("authToken", res?.data?.authToken);
        props.handleLoginStateChange();
        navigate(props.redirectTo);
      }
    }).catch(err => console.log(err));
  }, [navigate, props, queryString]);
  (0, _react.useEffect)(() => {
    getGoogleAuthToken();
  }, [getGoogleAuthToken]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
var _default = exports.default = NicheGoogleAuthRedirect;